"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatsWidgetThresholdComparisonEnum = void 0;
var StatsWidgetThresholdComparisonEnum;
(function (StatsWidgetThresholdComparisonEnum) {
    StatsWidgetThresholdComparisonEnum["nEqNum"] = "not_equal_num";
    StatsWidgetThresholdComparisonEnum["EqNum"] = "equal_num";
    StatsWidgetThresholdComparisonEnum["EqNumTrend"] = "equal_num_trend";
    StatsWidgetThresholdComparisonEnum["Gt"] = "gt";
    StatsWidgetThresholdComparisonEnum["GtTrend"] = "gt_trend";
    StatsWidgetThresholdComparisonEnum["Gte"] = "gte";
    StatsWidgetThresholdComparisonEnum["GteTrend"] = "gte_trend";
    StatsWidgetThresholdComparisonEnum["Lt"] = "lt";
    StatsWidgetThresholdComparisonEnum["LtTrend"] = "lt_trend";
    StatsWidgetThresholdComparisonEnum["Lte"] = "lte";
    StatsWidgetThresholdComparisonEnum["LteTrend"] = "lte_trend";
    StatsWidgetThresholdComparisonEnum["AnyOfNum"] = "any_of_num";
    StatsWidgetThresholdComparisonEnum["NoneOfNum"] = "none_of_num";
})(StatsWidgetThresholdComparisonEnum = exports.StatsWidgetThresholdComparisonEnum || (exports.StatsWidgetThresholdComparisonEnum = {}));
